'use strict';

var GridDateReoptButtonController = function GridDateReoptButtonController($scope, scenarioService, reoptimizationService, featureToggleService) {
  var gridPanel = $scope.gridPanelScope;
  $scope.reoptimizePreviewEnabled = featureToggleService.isEnabled('MD_PREVIEW_REOPT');
  function isMarketGrid(gridId) {
    return gridId === 'market-demand-analysis';
  }
  function isMarketProductGroupAnalysisGrid(gridId) {
    return gridId === 'market-product-group-analysis' && !$scope.reoptimizePreviewEnabled;
  }
  function isServiceDemandAnalysisGrid(gridId) {
    return gridId === 'service-demand-analysis' && !$scope.reoptimizePreviewEnabled;
  }
  $scope.isReoptimizeButtonShown = false;
  $scope.onRowSelection = function (event, selectedRows) {
    $scope.selectedRows = selectedRows;
    $scope.dateReoptValid = !$scope.isDemandManagement || isOneOfIntegratedMarketDemandManagementGrids();
    $scope.isReoptimizeButtonShown = selectedRows.length > 0 && $scope.dateReoptValid;
  };
  function isOneOfIntegratedMarketDemandManagementGrids() {
    return isMarketGrid(gridPanel.gridId) || isMarketProductGroupAnalysisGrid(gridPanel.gridId) || isServiceDemandAnalysisGrid(gridPanel.gridId);
  }
  $scope.reoptimizeMarketGrid = function () {
    reoptimizationService.reoptimizeFromMarketScreen($scope.selectedRows, scenarioService.getSelectedScenarioName());
  };
};
GridDateReoptButtonController.$inject = ['$scope', 'ScenarioService', 'ReoptimizationService', 'FeatureToggleService'];
module.exports = GridDateReoptButtonController;